import { render, staticRenderFns } from "./admin-portal-api-users-layout.vue?vue&type=template&id=9d36cb34"
import script from "./admin-portal-api-users-layout.vue?vue&type=script&lang=js"
export * from "./admin-portal-api-users-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports